import { useQuery } from "react-query";
import { useLogs } from "./useLogs";
import { DataFilterIProps } from "../model/schema";

interface useGetIvideonLogFileHashIProps {
  send: boolean;
  dataFilter?: DataFilterIProps;
}

export const useGetIvideonLogFileHash = ({
  send,
  dataFilter,
}: useGetIvideonLogFileHashIProps) => {
  const { getIvideonLogsFileHash } = useLogs();

  const { data, isLoading, isError } = useQuery({
    queryKey: [
      "useGetIvideonLogFileHash",
      dataFilter ? JSON.stringify(dataFilter) : "",
    ],
    queryFn: () => getIvideonLogsFileHash(dataFilter),
    enabled: send,
    cacheTime: 0,
  });
  return { data: data?.data?.fileHash, isLoading, isError };
};
